import React, { useRef, useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import DateFnsUtils from '@date-io/date-fns'
import { Box, Button } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { useStyles } from './style'
import { AppButton } from '../../Components'

function CustomDatePicker(props) {
  const classes = useStyles()
  const outerRef = useRef()
  const [date, setDate] = useState(props.value || new Date())

  const handleOuterClick = (e) => {
    if (!outerRef.current.contains(e.target)) {
      props.handleCancel()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick)

    return () => {
      document.removeEventListener('mousedown', handleOuterClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDoneClick = () => {
    const obj = {
      date: date,
    }
    props.handleDone(obj)
  }

  const FormikDatePicker = () => {
    return (
      <DatePicker
        disableToolbar
        variant="static"
        format="dd-MM-yyyy"
        maxDate={props.maxDate}
        minDate={props.minDate}
        onChange={(value) => {
          setDate(value)
        }}
        value={moment(date, 'MM-DD-YYYY')}
        invalidLabel=''
        animateYearScrolling={false}
        renderDay={(day, selectedDate, isInCurrentMonth, dayComponent) => {
          const isToday = moment(day).isSame(moment(), "day");
          const isDisabled = dayComponent.props.disabled;

          return React.cloneElement(dayComponent, {
            style: isToday && isDisabled
              ? {
                  color: "#00000061",
                }
              : undefined,
          });
        }}
      />
    )
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Box className={classes.root} ref={outerRef}>
        <Box className={classes.calendarWrapper}>
          <Box>{FormikDatePicker()}</Box>
        </Box>
        <Box className={classes.buttonGroup}>
          <Button onClick={props.handleCancel}>Cancel</Button>
          <AppButton text="Done" className={classes.button} onClick={handleDoneClick} />
        </Box>
      </Box>
    </MuiPickersUtilsProvider>
  )
}

CustomDatePicker.defaultProps = {
  handleCancel: () => { },
  handleDone: () => { },
  value: '',
  format: '',
}

export default CustomDatePicker